module.exports = __webpack_public_path__ + "img/filter.a98c73c0.svg";